// eslint-disable-next-line jira/filename-case
import { createHook } from './useOnboardingFlowsActions.tsx';
import { getProductUsageStartTimestamp } from './getProductUsageStartTimestamp.tsx';

export const useProductUsageStartTimestamp: () => string | undefined = createHook(
	getProductUsageStartTimestamp,
);
